import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-data-mining-list',
  templateUrl: './data-mining-list.component.html',
  styleUrls: ['./data-mining-list.component.css']
})
export class DataMiningListComponent implements OnInit {
    public itemsListDataMinings: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadDataMinings() {
        this.itemsListDataMinings = await this.datatask.Post(811);
    }

    private async init() {
        this.loadDataMinings();
    }

    ngOnInit() {
        this.init();
    }
}
